<template>
    <div :class="heading === 'How many people use the internet in your home?' ? 'grid grid-cols-2 gap-4' : ''">
        <div v-for="(answer, index) in items"
             :key="index"
             :id="'quiz-answer-' + index"
             class="shadow
                    bg-white
                    rounded-md
                    flex
                    cursor-pointer
                    quiz-answer"
             :class="[(selectedAnswer === index && theme === 'themeSalmon') ? ' shadow-xl transition duration-300 transform scale-105 border-blue-500' : '',
                     heading === 'How many people use the internet in your home?' && theme === 'themeSalmon' ? '' : 'mb-2',
                     heading === 'How many people use the internet in your home?' && theme === 'themeAlt' ? 'py-3' : 'mb-2']"
             @click="answerQuestion(index)">
            <QuizItem :answer="answer" :theme="theme" :selected="selectedAnswer === index" />
        </div>
    </div>
</template>

<script>
    import QuizItem from './QuizItem.vue'
    export default {
        name: 'QuizItems',
        components: { QuizItem },
        props: {
            items: {
                type: Array,
                default: [],
            },
            answerQuestion: {
                type: Function,
                default: null,
            },
            selectedAnswer: {
                type: Number,
                default: null,
            },
            heading: {
                type: String,
                default: '',
            },
            theme: {
                type: String,
                default: '',
            }
        },
    }
</script>
